import { LitElement, html, TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GlobalExclusionsEvents } from '../../exclusionsPanel/types';
import { Rights } from '@nirvana/shared/constants';

export class ExclusionListDetailsPanelWebComponent extends LitElement {
  @property({
    type: String,
    reflect: true,
  })
  listId = '';

  @property({
    type: String,
    reflect: true,
  })
  createdByTitle = '';

  @property({
    type: String,
    reflect: true,
  })
  createdOnTitle = '';

  @property({
    type: String,
    reflect: true,
  })
  editedByTitle = '';

  @property({
    type: String,
    reflect: true,
  })
  editedOnTitle = '';

  @property({
    type: String,
    reflect: true,
  })
  descriptionTitle = '';

  @property({
    type: String,
    reflect: true,
  })
  @property({ type: String, reflect: true })
  generalTitle = '';

  @property({ type: String, reflect: true })
  detailsTitle = '';

  @property({ type: String, reflect: true })
  name = '';

  @property({
    type: String,
    reflect: true,
  })
  createdBy = '';

  @property({
    type: Date,
    reflect: true,
  })
  createdOn = '';

  @property({
    type: String,
    reflect: true,
  })
  editedBy = '';

  @property({
    type: String,
    reflect: true,
  })
  editedOn = '';

  @property({
    type: String,
    reflect: true,
  })
  description = '';

  @property({ type: String, reflect: true })
  assignToPolicyButtonLabel = '';

  @property({ type: Boolean, attribute: true, reflect: true })
  shouldDisplayEditedDate = false;

  @property({ type: String, reflect: true })
  deleteButtonLabel = '';
  policies: any;

  static get styles() {
    return styles;
  }

  protected render() {
    return html`
      <div class="details-panel-wrapper">
        <div class="details-panel">${this.renderHeader()} ${this.renderContent()}</div>
      </div>
    `;
  }

  private renderHeader(): TemplateResult {
    return html`
      <div class="details-panel-header">
        <gz-title class="title" fontweight="400" fontsize="16">${this.name}</gz-title>
      </div>
    `;
  }

  private renderContent(): TemplateResult {
    return html` ${this.renderGeneralSection()} ${this.renderDetailsSection()} ${this.renderButtonsSection()} `;
  }

  private renderGeneralSection(): TemplateResult {
    return html`
      <div class="details-panel-content-title">
        <gz-labeled-content label="${this.generalTitle}"></gz-labeled-content>
      </div>
      <table>
        <gz-labeled-content label="${this.createdByTitle}">
          ${this.createdBy}
        </gz-labeled-content>
        <gz-labeled-content label="${this.createdOnTitle}">
          ${this.createdOn}
        </gz-labeled-content>
        ${this.renderEdited()}
        </tr />
      </table>
    `;
  }

  private renderEdited() {
    if (this.shouldDisplayEditedDate) {
      return html`
        <gz-labeled-content label="${this.editedByTitle}"> ${this.editedBy} </gz-labeled-content>
        <gz-labeled-content label="${this.editedOnTitle}"> ${this.editedOn} </gz-labeled-content>
      `;
    }
  }

  private renderDetailsSection(): TemplateResult {
    return html`
      <div class="details-panel-details-wrapper">
        <gz-labeled-content class="details-panel-content-title" label="${this.detailsTitle}"></gz-labeled-content>

        <hr />

        <gz-title class="py-1 section-title" fontweight="500" fontsize="12">Description</gz-title>
        <gz-text class="py-1" fontweight="400" fontsize="12">${this.description}</gz-text>
      </div>
    `;
  }

  private renderButtonsSection(): TemplateResult {
    const disabled = !Application.Main.hasAllRights([Rights.MANAGE_POLICIES_WRITE]);
    return html`
      <div class="details-panel-actions">
        <gz-button
          id="confirm"
          buttonheight="small"
          buttonfontsize="medium"
          type="full"
          color="primary"
          class="mr-2"
          @click="${this.triggerAssignListToPolicies}"
          .disabled="${disabled}"
          >${this.assignToPolicyButtonLabel}</gz-button
        >
        <gz-button
          id="delete"
          buttonheight="small"
          buttonfontsize="medium"
          type="outline"
          color="negative"
          class="mr-2"
          @click="${this.triggerDeleteExclusionList}"
          .disabled="${disabled}"
          >${this.deleteButtonLabel}</gz-button
        >
      </div>
    `;
  }

  private triggerDeleteExclusionList(event) {
    this.dispatchEvent(
      new CustomEvent(GlobalExclusionsEvents.DELETE_EXCLUSION_LIST, {
        detail: {
          list: this.listId,
          listName: this.name,
          policies: this.policies,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  private triggerAssignListToPolicies(event) {
    this.dispatchEvent(
      new CustomEvent(GlobalExclusionsEvents.ASSIGN_LIST_TO_POLICIES, {
        detail: {
          list: this.listId,
          listName: this.name,
          inPolicies: this.policies,
        },
        bubbles: true,
        composed: true,
      })
    );
  }
}
